import { InjectionToken } from '@angular/core';

/**
 * Injection token to provide the
 */
export const CONNECTED_PLAYER_VOLUME = new InjectionToken<number>(
  'bmat.angular.media-players.connected-player-volume',
);
